// @ts-nocheck

import React from 'react';
import styled, { css } from 'styled-components';

import { OddArrow } from '../../assets/svg';
import Formatter from '../../i18n/formatter';
import { __ } from '../../i18n/l10n';
import theme from '../../styled-components/dark';
import { OddsChanges } from '../../types/basket';
import type { OddsChange } from '../../types/basket';

const WrapOdd = styled.div`
  margin: 0;
  display: flex;
  flex-direction: ${({ $flexDirection }) => $flexDirection};
  align-items: ${({ $displayLabel }) => ($displayLabel ? 'flex-end' : 'center')};
  justify-content: flex-end;
  font-size: 110%;

  color: ${({ $highlight, $isUp }) => {
    if ($highlight) {
      if ($isUp) {
        return theme.Odd.isUp;
      }
      return theme.Odd.isDown;
    }
    return theme.Odd.normal;
  }};
`;

const ValueWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
`;

const WrapArrows = styled.span`
  display: inline-block;
  margin: 0 0.4em;
`;

const CanceledOdd = styled.span`
  text-decoration: line-through;
  opacity: 0.7;
  font-size: 1.1em;
  margin-right: 0.3em;
`;

const ValidatedOdd = styled.span`
  font-weight: bold;
  font-size: 1.1em;
`;

const OddValue = styled.span`
  font-size: 1.1em;
  font-weight: bold;
  margin-left: 0.1em;
`;

const Label = styled.span`
  font-size: 0.8em;
  color: ${({ $highlight }) => ($highlight ? 'inherit' : theme.BasketCard.subLabelColor)};
  margin-bottom: ${({ $flexDirection }) => ($flexDirection === 'column' ? 0.3 : 0)}em;
`;

const Arrow = styled(OddArrow)`
  height: 0.4em;
  display: block;
  width: auto;
  ${({ $isUp }) => {
    if ($isUp) {
      return css`
        color: ${theme.Odd.isUp};
      `;
    }
    return css`
      transform: rotate(180deg);
      color: ${theme.Odd.isDown};
    `;
  }}
`;

type BasketOddsProps = {
  className?: string;
  validatedValue?: number | null;
  value: number;
  changed: OddsChange | null;
  displayLabel?: boolean;
  flexDirection?: string;
};

const BasketOdds = ({
  className,
  validatedValue,
  value,
  changed,
  displayLabel = true,
  flexDirection = 'row',
}: BasketOddsProps) => {
  const highlight = !!changed;
  const isUp = changed === OddsChanges.UP;

  return (
    <WrapOdd
      className={className}
      $highlight={highlight}
      $isUp={isUp}
      $flexDirection={flexDirection}
      $displayLabel={displayLabel}
    >
      {flexDirection === 'row' && highlight ? (
        <WrapArrows>
          <Arrow $isUp={isUp} title={`arrow-${isUp ? 'up' : 'down'}`} />
          <Arrow $isUp={isUp} title={`arrow-${isUp ? 'up' : 'down'}`} />
        </WrapArrows>
      ) : null}
      {displayLabel ? (
        <>
          <Label $flexDirection={flexDirection} $highlight={highlight}>
            {__('Odds')}
          </Label>
          {flexDirection === 'row' ? <>&nbsp;</> : ''}
        </>
      ) : null}
      <ValueWrapper>
        {flexDirection === 'column' && highlight ? (
          <WrapArrows>
            <Arrow $isUp={isUp} title={`arrow-${isUp ? 'up' : 'down'}`} />
            <Arrow $isUp={isUp} title={`arrow-${isUp ? 'up' : 'down'}`} />
          </WrapArrows>
        ) : null}

        {validatedValue ? (
          <>
            <CanceledOdd>{value ? Formatter.formatOdd(value) : '-'}</CanceledOdd>{' '}
            <ValidatedOdd>{validatedValue ? Formatter.formatOdd(validatedValue) : '-'}</ValidatedOdd>
          </>
        ) : (
          <OddValue>{value ? Formatter.formatOdd(value) : '-'}</OddValue>
        )}
      </ValueWrapper>
    </WrapOdd>
  );
};

export default BasketOdds;
